<template>
  <div class="form-course-item">
    <div class="form-item-title">{{ column.label }}:</div>
    <div>
      <van-radio-group v-model="value" @change="radioGroupChange">
        <van-radio :name="item.value" v-for="(item, index) in dicData" :key="index">{{ item.label }}</van-radio>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import {uuid} from '@/ultis'
export default {
  props: ['column'],
  data() {
    const preDeel = obj => {
      const newObj = obj.map(item => ({...item, value: uuid() + '_' + item.value}))
      return newObj
    }
    return {
      dicData: preDeel(this.column.dicData),
      value: ''
    }
  },
  methods: {
    radioGroupChange(val) {
      const target = this.dicData.filter(item => item.value === val)[0]
      const params1 = this.column.prop
      const params2 = '$' + this.column.prop
      const obj = {
        [params1]: target.value.split('_')[1],
        [params2]: target.label
      }
      this.$store.commit('setReport', obj)
    }
  }
}
</script>

<style>
.form-course-item .van-radio {
  margin-bottom: 10px;
}
</style>
